import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { I18NService } from '@ebw-monorepo/i18n-translate';
import { ExternalActionService } from '@ebw-monorepo/map';
import { EbwModalService } from '@ebw-monorepo/modal';
import { MapRequestService } from '../../../../services/map-request.service';
import { IHttpMapGet } from './../../../../interfaces/httpReq.interface';
import { IQueryDataset } from './../../../../interfaces/query.interface';
import { Query } from './../../../../models/query.model';
import { QueryService } from './../../../../services/query.service';
import { QueryFormComponent } from './../query-form/query-form.component';
import { API_URLS, ApiUrlService } from '../../../../../../../utils/src/lib/services/api-url.service';
import { LoginService } from '@ebw-monorepo/login';

export enum QUERY_TYPE {
  STANDARD = 0,
  ADVANCED = 1
}

@Component({
  selector: 'ebw-monorepo-query-tabs',
  templateUrl: './query-tabs.component.html',
  styleUrls: ['./query-tabs.component.scss']
})
export class QueryTabsComponent implements OnInit, OnDestroy {
  title: string = 'map.sidebar.query.new_query';
  id: number = null;
  dataset: string = 'water';
  query: Query = null;

  data_mod_temp: string = '';

  showHtml: boolean = false;
  tabIndex = QUERY_TYPE.STANDARD;

  datasets: IQueryDataset[];

  @ViewChild(QueryFormComponent) form: QueryFormComponent;

  constructor(
    private httpSrv: MapRequestService,
    private route: ActivatedRoute,
    private router: Router,
    private ebwModalSrv: EbwModalService,
    private i18nSrv: I18NService,
    private querySrv: QueryService,
    private datePipe: DatePipe,
    private externalSrv: ExternalActionService,
    private _apiUrlService: ApiUrlService
  ) {
    let state = this.router.getCurrentNavigation().extras.state;
    if (state) {
      this.title = state.title;
      this.id = state.id ? state.id : null;
      this.datasets = state.datasets;
    }
  }

  ngOnInit(): void {
    if (this.id) {
      this.getQuery();
    } else {
      this.showHtml = true;
    }
  }

  getQuery() {
    let req: IHttpMapGet = {
      url: this._apiUrlService.createUrl(API_URLS.MAP.QUERY.GET) + '?id=' + this.id
    };
    this.httpSrv.getMapRequest(req).subscribe({
      next: async (resp: any) => {
        this.dataset = resp[0].dataset;
        this.query = new Query(resp[0]);
        if (this.query && this.query.query_script) {
          this.tabIndex = QUERY_TYPE.ADVANCED;
        }
        this.showHtml = true;
      },
      error: (error) => {
        this.ebwModalSrv.openErrorModal({
          title: 'common.error',
          content: 'common.data_retrieving_error'
        });
      }
    });
  }

  tabClick(event) {
    switch (event.index) {
      case 0:
        this.tabIndex = QUERY_TYPE.STANDARD;
        break;
      case 1:
        this.tabIndex = QUERY_TYPE.ADVANCED;
        break;
    }
  }

  saveQuery() {
    let req: IHttpMapGet = {
      url: this._apiUrlService.createUrl(API_URLS.MAP.QUERY.ADD)
    };

    let body = new Query(this.form.queryForm.value);

    let date_mod = this.datePipe.transform(new Date(), 'yyyy-MM-dd HH:mm:ss');
    // Qui assegno le timestamp, la decisione sul quale scrivere sul db avviene direttamente nelle api

    /** Se sono in query standard (tabIndex = 0) devo aggiungere la posizione agli array */
    if (!this.tabIndex) {
      body.orderPositionCond();
      body.orderPositionQuery();
    }

    body.user_id = sessionStorage.getItem(LoginService.USER_ID_KEY);

    // Qui assegno le timestamp, la decisione sul quale scrivere sul db avviene direttamente nelle api
    body.date_modified = date_mod;
    body.date_created = date_mod;

    /** controllo se sono in modifica */
    if (this.id) {
      body.id = this.id;
      req.url = this._apiUrlService.createUrl(API_URLS.MAP.QUERY.UPDATE);
    }

    if (!this.validatorQueryFn(body)) {
      const controls = this.form.queryForm.controls;
      for (const name in controls) {
        if (controls[name].invalid) {
          controls[name].markAsTouched();
          controls[name].markAsDirty();
        }
      }
      return;
    }
    this.httpSrv.postMapRequest(req, body).subscribe({
      next: (resp: any) => {
        this.ebwModalSrv.openSuccessModal({
          title: this.i18nSrv.getInstantValue(this.title),
          content: this.i18nSrv.getInstantValue('common.save_successful')
        });

        this.id = resp.id;
        this.query = resp;
      },
      error: (error) => {
        console.error('[saveQuery] ', error);
        this.ebwModalSrv.openErrorModal({
          title: this.i18nSrv.getInstantValue(this.title),
          content: this.i18nSrv.getInstantValue('common.error_saving')
        });
      }
    });
  }

  queryExec() {
    let config = {
      id: this.id,
      url: this._apiUrlService.createUrl(API_URLS.MAP.QUERY.EXEC),
      title: 'map.map_table.results_query',
      pagination: true,
      marker: 'place',
      infoColumn: true,
      pinnableRow: true,
      queryName: this.query.query_name
    };
    this.querySrv.queryExec(config);
  }

  validatorQueryFn(data: Query) {
    /** di default metto la validazione a true */
    let resp = true;
    /**controllo che la form sia valida */
    if (this.form.queryForm.invalid) {
      resp = false;
      return resp;
    }

    switch (this.tabIndex) {
      /**query standard */
      case 0:
        break;
      /**query avanzata */
      case 1:
        //se ho inserito una query che si aspetta la geometria, verifico che sia stata inserita nelle condizioni
        if (data.query_script && this.form.showAdvancedTrail && data.asset_query_cond.length == 0) {
          this.ebwModalSrv.openErrorModal({
            title: this.i18nSrv.getInstantValue('common.error'),
            content: this.i18nSrv.getInstantValue('map.sidebar.query.error_insert_geometry')
          });
          resp = false;
        }
        break;
    }

    return resp;
  }

  deleteQuery(id: number, name: string) {
    let req: IHttpMapGet = {
      url: this._apiUrlService.createUrl(API_URLS.MAP.QUERY.UPDATE)
    };

    let body = {
      id: id,
      user_id: sessionStorage.getItem(LoginService.USER_ID_KEY),
      deleted: 1
    };

    this.querySrv.deleteQuery(req, body, name, this.backToQueryList.bind(this));
  }

  backToQueryList() {
    this.router.navigate(['/home', { outlets: { sidebarAction: ['query'] } }], {
      relativeTo: this.route
    });
  }

  ngOnDestroy() {
    this.externalSrv.nextViewerManager(false);
  }
}
